import { E as EmberTesting } from '../shared-chunks/public-api-BQsJemZG.js';
import { registerTestImplementation } from '../@ember/test/index.js';
export { default as Test } from './lib/test.js';
export { default as Adapter } from './lib/adapters/adapter.js';
export { default as setupForTesting } from './lib/setup_for_testing.js';
export { default as QUnitAdapter } from './lib/adapters/qunit.js';

registerTestImplementation(EmberTesting);
